export default "__VITE_ASSET__C8f8zP3G__"